import type { LoaderFunction } from 'react-router';
import type { RouteProps } from '../../shared/RouteProps';

export const writeAReviewLoader =
  ({ services }: RouteProps): LoaderFunction =>
  async ({ params, request }): Promise<string> => {
    return 'writeAReviewLoader';
  };
